import { createContext, useContext } from 'react'

export interface CommandSearchControl {
  /** True for admin/team: the only roles the search endpoint answers. */
  available: boolean
  open: () => void
}

/** Outside `CommandSearchHost` (founder pages, isolated tests) there is no search. */
export const CommandSearchContext = createContext<CommandSearchControl>({
  available: false,
  open: () => {},
})

export function useCommandSearch(): CommandSearchControl {
  return useContext(CommandSearchContext)
}
